import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  SEARCH_HISTORY_KEY: 'searchHistory',
  SEARCH_TYPE_IS_ENTERPRISE: 1,
  SEARCH_MAX_HISTORY: 10,
  SEARCH_GET_PRODUCT_BY_HOME: 1,
  SEARCH_GET_PRODUCT_BY_SEARCH: 2,

  // 搜索接口版本version
  SEARCH_API_TYPE_V1: 'v1',
  SEARCH_API_TYPE_V2: 'v2',
  SEARCH_API_TYPE_V3: 'v3',
}, km({
  SEARCH_CHANGE_TEXT: null,

  SEARCH_GET_HISTORY_START: null,
  SEARCH_GET_HISTORY_SUCCESS: null,
  SEARCH_GET_HISTORY_ERROR: null,

  SEARCH_SET_HISTORY_START: null,
  SEARCH_SET_HISTORY_SUCCESS: null,
  SEARCH_SET_HISTORY_ERROR: null,

  SEARCH_CLEAR_HISTORY_START: null,
  SEARCH_CLEAR_HISTORY_SUCCESS: null,
  SEARCH_CLEAR_HISTORY_ERROR: null,

  SEARCH_REMOVE_HISTORY_START: null,
  SEARCH_REMOVE_HISTORY_SUCCESS: null,
  SEARCH_REMOVE_HISTORY_ERROR: null,

  SEARCH_GET_RESULT_START: null,
  SEARCH_GET_RESULT_SUCCESS: null,
  SEARCH_GET_RESULT_ERROR: null,

  SEARCH_GET_RESULT_MORE_START: null,
  SEARCH_GET_RESULT_MORE_SUCCESS: null,
  SEARCH_GET_RESULT_MORE_ERROR: null,


  SEARCH_GET_RESULT_START_V2: null,
  SEARCH_GET_RESULT_SUCCESS_V2: null,
  SEARCH_GET_RESULT_ERROR_V2: null,

  SEARCH_GET_RESULT_MORE_START_V2: null,
  SEARCH_GET_RESULT_MORE_SUCCESS_V2: null,
  SEARCH_GET_RESULT_MORE_ERROR_V2: null,

  SEARCH_GET_RESULT_START_V3: null,
  SEARCH_GET_RESULT_SUCCESS_V3: null,
  SEARCH_GET_RESULT_ERROR_V3: null,

  SEARCH_GET_RESULT_MORE_START_V3: null,
  SEARCH_GET_RESULT_MORE_SUCCESS_V3: null,
  SEARCH_GET_RESULT_MORE_ERROR_V3: null,

  SEARCH_GET_HOT_WORDS_SUCCESS: null,
  SEARCH_GET_HOT_WORDS_ERROR: null,

  SEARCH_GET_RECOMMEND_PRODUCT_SUCCESS: null,
  SEARCH_GET_RECOMMEND_PRODUCT_ERROR: null,
  SEARCH_GET_RECOMMEND_PRODUCT_MORE_SUCCESS: null,
  SEARCH_GET_RECOMMEND_PRODUCT_MORE_ERROR: null,

  SEARCH_GET_SHADING_HOTWORDS_SUCCESS: null
}))
